var map = {
	"./education.svg": 1428,
	"./education.svg:Zone.Identifier": 5530,
	"./interests.svg": 3372,
	"./interests.svg:Zone.Identifier": 9633,
	"./programming-skills.svg": 821,
	"./programming-skills.svg:Zone.Identifier": 1980,
	"./projects.svg": 7051,
	"./projects.svg:Zone.Identifier": 2353,
	"./work-history.svg": 4101,
	"./work-history.svg:Zone.Identifier": 8601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;